import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';


export const WrapperCats = styled.div`
    padding: ${rem(40)} 0 ${rem(80)} 0;

    @media (min-width: ${breakpoints.sm}px) {
        padding: ${rem(80)} 0 ${rem(0)} 0;
    }
`;

export const Wrapper = styled.div`
    padding-bottom: ${rem(40)};

    @media (min-width: ${breakpoints.md}px) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const Categories = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: ${rem(45)};
    gap: ${rem(15)};

    @media (min-width: ${breakpoints.sm}px) {
        justify-content: center;
        flex-wrap: unset;
    }
`;

export const Category = styled.button`
    background: none;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${rem(12)};
    padding: ${rem(14)} ${rem(20)};
    cursor: pointer;
    width: 45%;

    &.active {
        border-color: ${({ theme }) => theme.colors.primary};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    @media (min-width: ${breakpoints.sm}px) {
        width: auto;
    }
`;

export const Areas = styled.div`
    padding: 0 ${rem(10)};
    margin-top: ${rem(20)};

    @media (min-width: ${breakpoints.xs}px) {
        display: flex;
        flex-direction: row;
    }

    @media (min-width: ${breakpoints.md}px) {
        padding: 0;
    }
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;

    @media (min-width: ${breakpoints.xs}px) {
        width: ${rem(350)};
    }
`;

export const Area = styled.span`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(25)};
    color: ${({ theme }) => theme.colors.grey};
    margin-bottom: ${rem(25)};
    padding-right: ${rem(15)};

    svg {
        width: ${rem(18)};
        height: ${rem(18)};
        margin-right: ${rem(10)};
        margin-bottom: ${rem(-2)};
    }
`;

export const Image = styled.img`
    display: block;
    width: 55%;
    margin: ${rem(20)} auto;

    @media (min-width: ${breakpoints.md}px) {
        width: 35%;
        margin: 0;
    }
`;
